var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamdashboardimg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 320.759,
    height: 171.78,
    viewBox: "0 0 320.759 171.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_team_collaboration_re_ow29",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7067",
    "data-name": "Group 7067",
    transform: "translate(173.683 107.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17645",
    "data-name": "Path 17645",
    d: "M73.538,0c40.614,0,73.538,28.345,73.538,63.31H0C0,28.345,32.924,0,73.538,0Z",
    transform: "translate(0)",
    fill: "#ffcd50"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_17686",
    "data-name": "Path 17686",
    d: "M165.273,614.637l-.993,4.98c-.075.381-.153.768-.238,1.152a4.858,4.858,0,0,0-2.5.139,23.3,23.3,0,0,1,1.713,2.866,10.547,10.547,0,0,1-3.08,5,7.724,7.724,0,0,1-7.462,1.312l.044-.2c-1.652-3.206-.755-7.248,1.3-10.209a19.848,19.848,0,0,1,3.689-3.9c1.387-1.156,2.886-2.193,4.372-3.216a2.036,2.036,0,0,1,3.151,2.074Z",
    transform: "translate(-145.117 -471.171)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a4b268fa-75d0-4ac1-9d87-14bdca948464-2189",
    d: "M154.075,661.66a39.95,39.95,0,0,1-.554-9.2,14.473,14.473,0,0,1,2.791-7.588,12.623,12.623,0,0,1,3.239-2.935c.324-.2.622.309.3.512a12,12,0,0,0-4.747,5.727,19.213,19.213,0,0,0-1.02,8.286c.108,1.689.336,3.366.566,5.042a.306.306,0,0,1-.207.365.3.3,0,0,1-.365-.207Z",
    transform: "translate(-146.12 -490.764)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17687",
    "data-name": "Path 17687",
    d: "M164.932,248.574q21.844-.38,43.694-.109t43.677,1.2q12.25.52,24.491,1.245c.656.039.653-.981,0-1.02q-21.81-1.291-43.651-1.931t-43.689-.625q-12.261.008-24.522.222a.51.51,0,0,0,0,1.02Z",
    transform: "translate(-153.391 -230.34)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17688",
    "data-name": "Path 17688",
    d: "M463.471,229.271l6.368-.474c.651-.048.656-1.069,0-1.02l-6.368.474C462.82,228.3,462.815,229.32,463.471,229.271Z",
    transform: "translate(-350.44 -217.433)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17689",
    "data-name": "Path 17689",
    d: "M463.471,247.271l6.368-.474c.651-.048.656-1.069,0-1.02l-6.368.474C462.82,246.3,462.815,247.32,463.471,247.271Z",
    transform: "translate(-350.44 -229.314)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17690",
    "data-name": "Path 17690",
    d: "M462.064,239.97l9.054.822c.653.059.649-.961,0-1.02l-9.054-.822C461.411,238.891,461.415,239.911,462.064,239.97Z",
    transform: "translate(-349.513 -224.807)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17691",
    "data-name": "Path 17691",
    d: "M172.517,228.141a2.256,2.256,0,0,0-2.085,1.362,2.031,2.031,0,0,0,.467,2.412,2.414,2.414,0,0,0,2.288.465,2.041,2.041,0,0,0,1.368-1.918,2.28,2.28,0,0,0-1.421-2.2.512.512,0,0,0-.627.356.524.524,0,0,0,.356.627c.089.034-.081-.044,0,0,.034.019.069.035.1.055s.056.035.083.053c.1.062-.046-.046.014.01s.105.1.153.149c.018.02.089.076.034.037s-.016-.023,0,0l.038.055a1.82,1.82,0,0,1,.108.187l.022.045c.014.028.035.035,0,0s-.012-.031,0,0,.016.042.023.063a1.964,1.964,0,0,1,.06.21c.007.033.013.066.02.1.023.117,0-.073,0,.014s.01.144.009.217q0,.05,0,.1c0,.017,0,.033,0,.05-.005.08-.005-.029.006-.037a.941.941,0,0,0-.046.21c-.009.032-.02.063-.03.094-.035.109.033-.06,0,.015a1.865,1.865,0,0,1-.1.187c-.017.025-.079.082-.028.043s-.029.031-.047.05-.047.048-.072.071a.58.58,0,0,1-.051.044s.085-.059.038-.029-.118.08-.182.114c-.007,0-.089.042-.089.043,0-.014.1-.038.031-.014l-.047.016a1.668,1.668,0,0,1-.207.055c-.016,0-.033,0-.049.009-.053.014.05-.008.053-.006a.445.445,0,0,0-.116.01,1.889,1.889,0,0,1-.217,0l-.05,0c-.039,0-.067-.03-.016,0s.037.006,0,0l-.05-.009a1.977,1.977,0,0,1-.212-.052c-.038-.011-.074-.025-.111-.038a.3.3,0,0,1-.047-.018s.1.046.045.018-.13-.063-.192-.1c-.033-.02-.065-.042-.1-.063a.314.314,0,0,1-.04-.029s.079.068.038.029-.107-.094-.156-.146l-.033-.037-.011-.012q-.041-.051,0,0c.027.008.026.038,0,0l-.028-.041a1.064,1.064,0,0,1-.105-.188s.044.123.012.029c-.006-.018-.013-.035-.019-.053q-.018-.053-.031-.107c-.009-.036-.013-.073-.022-.108-.015-.06.009.047.006.045s0-.06-.006-.073c0-.08.005-.158.006-.237,0-.062-.005.048-.006.045a.172.172,0,0,1,.01-.054c.009-.042.018-.084.029-.125s.028-.094.045-.141c.006-.017.014-.034.02-.052.021-.064-.042.077-.007.02.049-.079.085-.165.136-.244.012-.019.086-.122.047-.07s.04-.047.055-.063c.063-.07.136-.127.2-.194.038-.039-.027.019-.031.022l.06-.043q.053-.037.109-.069c.042-.025.089-.043.13-.069s-.037.013-.038.014a.38.38,0,0,1,.068-.026c.039-.014.211-.088.247-.065,0,0-.13.01-.026,0l.074,0c.05,0,.1,0,.149,0a.513.513,0,0,0,.51-.51.521.521,0,0,0-.51-.51Z",
    transform: "translate(-157.207 -217.674)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17692",
    "data-name": "Path 17692",
    d: "M193.517,228.141a2.256,2.256,0,0,0-2.085,1.362,2.031,2.031,0,0,0,.467,2.412,2.414,2.414,0,0,0,2.287.465,2.041,2.041,0,0,0,1.368-1.918,2.28,2.28,0,0,0-1.421-2.2.512.512,0,0,0-.627.356.524.524,0,0,0,.356.627c.089.034-.081-.044,0,0,.034.019.069.035.1.055s.056.035.083.053c.1.062-.046-.046.014.01s.105.1.153.149c.018.02.089.076.034.037s-.016-.023,0,0l.038.055a1.817,1.817,0,0,1,.108.187l.022.045c.014.028.035.035,0,0s-.012-.031,0,0,.016.042.023.063a1.964,1.964,0,0,1,.06.21c.007.033.013.066.02.1.023.117,0-.073,0,.014s.01.144.009.217q0,.05,0,.1c0,.017,0,.033,0,.05-.005.08-.005-.029.006-.037a.941.941,0,0,0-.046.21c-.009.032-.02.063-.03.094-.035.109.033-.06,0,.015a1.862,1.862,0,0,1-.1.187c-.017.025-.079.082-.028.043s-.029.031-.047.05-.047.048-.072.071a.585.585,0,0,1-.051.044s.085-.059.038-.029-.118.08-.182.114c-.007,0-.089.042-.089.043,0-.014.1-.038.03-.014l-.047.016a1.668,1.668,0,0,1-.207.055c-.016,0-.033,0-.049.009-.053.014.05-.008.053-.006a.445.445,0,0,0-.116.01,1.89,1.89,0,0,1-.217,0l-.05,0c-.039,0-.067-.03-.016,0s.037.006,0,0l-.05-.009a1.978,1.978,0,0,1-.212-.052c-.038-.011-.074-.025-.111-.038a.3.3,0,0,1-.047-.018s.1.046.045.018-.13-.063-.192-.1c-.033-.02-.065-.042-.1-.063a.314.314,0,0,1-.04-.029s.079.068.038.029-.107-.094-.156-.146l-.033-.037-.011-.012q-.041-.051,0,0c.027.008.026.038,0,0l-.028-.041a1.064,1.064,0,0,1-.105-.188s.044.123.012.029c-.006-.018-.013-.035-.019-.053q-.018-.053-.031-.107c-.009-.036-.013-.073-.022-.108-.015-.06.009.047.006.045s0-.06-.006-.073c0-.08.005-.158.006-.237,0-.062-.005.048-.006.045a.173.173,0,0,1,.01-.054c.009-.042.018-.084.029-.125s.028-.094.045-.141c.006-.017.014-.034.02-.052.021-.064-.042.077-.007.02.049-.079.085-.165.136-.244.012-.019.086-.122.047-.07s.04-.047.055-.063c.063-.07.136-.127.2-.194.038-.039-.027.019-.031.022l.06-.043q.053-.037.109-.069c.042-.025.089-.043.13-.069s-.037.013-.038.014a.38.38,0,0,1,.068-.026c.039-.014.211-.088.247-.065,0,0-.13.01-.026,0l.074,0c.05,0,.1,0,.149,0a.513.513,0,0,0,.51-.51.521.521,0,0,0-.51-.51Z",
    transform: "translate(-171.068 -217.674)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17693",
    "data-name": "Path 17693",
    d: "M214.517,228.141a2.256,2.256,0,0,0-2.085,1.362,2.031,2.031,0,0,0,.467,2.412,2.414,2.414,0,0,0,2.288.465,2.041,2.041,0,0,0,1.368-1.918,2.28,2.28,0,0,0-1.421-2.2.512.512,0,0,0-.627.356.524.524,0,0,0,.356.627c.089.034-.081-.044,0,0,.034.019.069.035.1.055s.056.035.083.053c.1.062-.046-.046.014.01s.105.1.153.149c.018.02.089.076.034.037s-.016-.023,0,0l.038.055a1.817,1.817,0,0,1,.108.187l.022.045c.014.028.035.035,0,0s-.012-.031,0,0,.016.042.023.063a1.967,1.967,0,0,1,.06.21c.007.033.013.066.02.1.023.117,0-.073,0,.014s.01.144.009.217q0,.05,0,.1c0,.017,0,.033,0,.05-.005.08-.005-.029.006-.037a.941.941,0,0,0-.046.21c-.009.032-.02.063-.03.094-.035.109.033-.06,0,.015a1.865,1.865,0,0,1-.1.187c-.017.025-.079.082-.028.043s-.029.031-.047.05-.047.048-.072.071a.589.589,0,0,1-.051.044s.085-.059.038-.029-.118.08-.182.114c-.007,0-.089.042-.089.043,0-.014.1-.038.03-.014l-.047.016a1.669,1.669,0,0,1-.207.055c-.016,0-.033,0-.049.009-.053.014.05-.008.053-.006a.445.445,0,0,0-.116.01,1.89,1.89,0,0,1-.217,0l-.05,0c-.039,0-.067-.03-.016,0s.037.006,0,0l-.05-.009a1.979,1.979,0,0,1-.212-.052c-.038-.011-.074-.025-.111-.038a.3.3,0,0,1-.047-.018s.1.046.045.018-.13-.063-.192-.1c-.033-.02-.065-.042-.1-.063a.317.317,0,0,1-.04-.029s.079.068.038.029-.107-.094-.156-.146l-.033-.037-.011-.012q-.041-.051,0,0c.027.008.026.038,0,0l-.028-.041a1.066,1.066,0,0,1-.105-.188s.044.123.012.029c-.006-.018-.013-.035-.019-.053q-.018-.053-.031-.107c-.009-.036-.013-.073-.022-.108-.015-.06.009.047.006.045s0-.06-.006-.073c0-.08.005-.158.006-.237,0-.062-.005.048-.006.045a.173.173,0,0,1,.01-.054c.009-.042.018-.084.029-.125s.028-.094.045-.141c.006-.017.014-.034.02-.052.021-.064-.042.077-.007.02.049-.079.085-.165.136-.244.012-.019.086-.122.047-.07s.04-.047.055-.063c.063-.07.136-.127.2-.194.038-.039-.027.019-.031.022l.06-.043q.053-.037.109-.069c.042-.025.089-.043.13-.069s-.037.013-.038.014a.38.38,0,0,1,.068-.026c.039-.014.211-.088.247-.065,0,0-.13.01-.026,0l.074,0c.05,0,.1,0,.149,0a.513.513,0,0,0,.51-.51.521.521,0,0,0-.51-.51Z",
    transform: "translate(-184.929 -217.674)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17694",
    "data-name": "Path 17694",
    d: "M267.931,320.757H142.858a5.972,5.972,0,0,1-5.965-5.965V203.317a5.972,5.972,0,0,1,5.965-5.965H267.931a5.972,5.972,0,0,1,5.965,5.965V314.792A5.972,5.972,0,0,1,267.931,320.757ZM142.858,198.032a5.291,5.291,0,0,0-5.285,5.285V314.792a5.291,5.291,0,0,0,5.285,5.285H267.931a5.292,5.292,0,0,0,5.285-5.285V203.317a5.291,5.291,0,0,0-5.285-5.285Z",
    transform: "translate(-135.209 -197.352)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17695",
    "data-name": "Path 17695",
    d: "M152.875,417.814l43.984-.134,43.759-.133,24.685-.075a.51.51,0,0,0,0-1.02l-43.984.134-43.759.133-24.685.075a.51.51,0,0,0,0,1.02Z",
    transform: "translate(-145.432 -341.967)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17696",
    "data-name": "Path 17696",
    d: "M217.12,385.892l.272-16.059a.51.51,0,0,0-1.02,0l-.272,16.059A.51.51,0,0,0,217.12,385.892Z",
    transform: "translate(-187.489 -310.871)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17697",
    "data-name": "Path 17697",
    d: "M278.955,367.2l.663-20.185.189-5.767c.022-.656-1-.656-1.02,0l-.663,20.185-.189,5.767C277.914,367.851,278.934,367.851,278.955,367.2Z",
    transform: "translate(-228.302 -292.001)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17698",
    "data-name": "Path 17698",
    d: "M339.614,313.1c-.4,7.149-1.139,28.237-1.539,35.386-.037.656.983.654,1.02,0,.4-7.149,1.139-28.237,1.539-35.386C340.67,312.444,339.65,312.446,339.614,313.1Z",
    transform: "translate(-267.996 -273.426)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17699",
    "data-name": "Path 17699",
    d: "M403.733,387.905l-.125,6.872a.51.51,0,0,0,1.02,0c.148-8.116.526-7.851.568-10.142a.51.51,0,0,0-1.02,0S403.881,379.789,403.733,387.905Z",
    transform: "translate(-311.252 -320.019)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17700",
    "data-name": "Path 17700",
    d: "M464.088,342.985l.115,19.279.033,5.52a.51.51,0,0,0,1.02,0l-.115-19.279-.033-5.52a.51.51,0,0,0-1.02,0Z",
    transform: "translate(-351.171 -293.15)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17701",
    "data-name": "Path 17701",
    d: "M151.686,352.214c-.844-2.32,1.059-4.551,3.014-5.554,2.343-1.2,5.038-1.473,7.405-2.631,3.53-1.726,6.1-4.825,8.388-7.926,2.354-3.192,4.509-6.618,7.5-9.27a15.024,15.024,0,0,1,5.463-3.161,18.827,18.827,0,0,1,7.891-.53c5.446.663,10.494,2.912,15.748,4.342,4.954,1.348,10.412,2.106,15.275.01,2.47-1.065,4.491-2.851,6.661-4.4a22.2,22.2,0,0,1,6.938-3.347,20.632,20.632,0,0,1,14.756,1.3,19.8,19.8,0,0,1,9.339,9.856c2.154,5.146,1.874,10.9,1.17,16.315-.182,1.4-.4,2.8-.617,4.191-.1.642.882.919.983.271.876-5.586,1.75-11.348.66-16.969a20.553,20.553,0,0,0-7.592-12.366,21.093,21.093,0,0,0-13.908-4.389,22.8,22.8,0,0,0-7.64,1.7,31.6,31.6,0,0,0-6.828,4.217,17.912,17.912,0,0,1-7.3,3.6,21.747,21.747,0,0,1-8.155-.169c-5.518-1.031-10.662-3.395-16.134-4.606-5.069-1.122-10.54-1.234-15.079,1.63-3.492,2.2-5.959,5.623-8.327,8.925-2.347,3.273-4.724,6.774-8.156,9.01-2.094,1.364-4.447,1.867-6.789,2.634s-4.6,2.067-5.56,4.472a4.349,4.349,0,0,0-.089,3.112c.223.612,1.209.348.983-.271Z",
    transform: "translate(-144.162 -276.941)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17702",
    "data-name": "Path 17702",
    d: "M86.168,166.9h0Z",
    transform: "translate(-56.875 -110.164)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17703",
    "data-name": "Path 17703",
    d: "M215.925,359.5a2.027,2.027,0,0,0-2.456-.909,1.784,1.784,0,0,0-1.016.946c-.02.046-.031.095-.047.142s-.049.068-.068.105a2.025,2.025,0,0,0,3.159,2.42,2.181,2.181,0,0,0,.429-2.7Zm-1.277.866C214.651,360.389,214.65,360.413,214.647,360.363Zm-.13-.3Zm-.572.23Zm.136.115C214.113,360.424,214.1,360.422,214.081,360.413Zm.061.029.013-.006-.01,0h.007c.005,0,.006,0,.006,0,.061-.028.02-.014-.016,0h0a.231.231,0,0,0-.07-.022l-.007,0c-.02-.014-.118-.091-.027-.01-.02-.018-.04-.035-.058-.054a.266.266,0,0,1-.03-.037l-.035-.062,0-.011c0-.009,0-.013,0-.019s0-.012,0-.018a.221.221,0,0,0,.013-.057l0-.005c.015-.02.027-.044.041-.065-.074.112.029-.012.037-.028s0,0,0,0l.006,0c.023-.014.045-.029.068-.041s.137-.046.024-.014c.026-.007.05-.017.076-.023l.063-.01h.063c-.019,0,.064.021.089.024l.01.008c.021.015.046.029.068.043-.1-.064,0,.005.02.024s.022.023.032.035a.28.28,0,0,1,.026.036c.016.03.033.06.05.089l0,.007a.027.027,0,0,0,0,0,.8.8,0,0,0,.039.139.107.107,0,0,1,0,.012c0,.026,0,.052,0,.078v.005a.559.559,0,0,0-.51,0Z",
    transform: "translate(-184.863 -303.694)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17704",
    "data-name": "Path 17704",
    d: "M218.114,364.255s0,0,0,0Z",
    transform: "translate(-188.818 -307.515)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17705",
    "data-name": "Path 17705",
    d: "M218.113,364.255h0Z",
    transform: "translate(-188.817 -307.515)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17706",
    "data-name": "Path 17706",
    d: "M218.111,364.257h0Z",
    transform: "translate(-188.815 -307.516)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17707",
    "data-name": "Path 17707",
    d: "M86.177,166.9Z",
    transform: "translate(-56.882 -110.162)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17708",
    "data-name": "Path 17708",
    d: "M150.168,138.9h0Z",
    transform: "translate(-99.118 -91.683)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17709",
    "data-name": "Path 17709",
    d: "M279.925,331.5a2.027,2.027,0,0,0-2.456-.909,1.784,1.784,0,0,0-1.016.946c-.02.046-.031.095-.047.142s-.049.068-.068.105a2.025,2.025,0,0,0,3.159,2.42A2.181,2.181,0,0,0,279.925,331.5Zm-1.277.866C278.651,332.389,278.65,332.413,278.647,332.363Zm-.13-.3Zm-.572.23Zm.136.115C278.113,332.424,278.1,332.422,278.081,332.413Zm.061.029.013-.006-.01,0h.007c.005,0,.006,0,.006,0,.061-.028.02-.014-.016,0h0a.233.233,0,0,0-.07-.022l-.007,0c-.02-.014-.118-.091-.027-.01-.02-.018-.04-.035-.058-.054a.266.266,0,0,1-.03-.037l-.035-.062,0-.011c0-.009,0-.013,0-.019s0-.012,0-.018a.22.22,0,0,0,.013-.057l0,0c.015-.02.027-.044.041-.066-.074.112.029-.012.037-.028s0,0,0,0l.006,0c.023-.013.045-.029.068-.041s.137-.046.024-.014c.026-.007.05-.017.076-.023l.063-.01h.037l.025,0c-.019,0,.064.021.089.024l.01.008c.021.015.046.029.068.043-.1-.064,0,.005.02.024s.022.023.032.035a.276.276,0,0,1,.026.036c.016.03.033.06.05.089l0,.007a.023.023,0,0,0,0,0,.8.8,0,0,0,.039.139s0,.008,0,.012c0,.026,0,.052,0,.078v.005a.559.559,0,0,0-.51,0Z",
    transform: "translate(-227.106 -285.213)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17710",
    "data-name": "Path 17710",
    d: "M282.111,336.257h0Z",
    transform: "translate(-231.058 -289.035)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17711",
    "data-name": "Path 17711",
    d: "M150.177,138.9Z",
    transform: "translate(-99.125 -91.681)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17712",
    "data-name": "Path 17712",
    d: "M282.114,336.255s0,0,0,0Z",
    transform: "translate(-231.061 -289.034)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17713",
    "data-name": "Path 17713",
    d: "M282.113,336.255h0Z",
    transform: "translate(-231.06 -289.034)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17714",
    "data-name": "Path 17714",
    d: "M212.177,152.9Z",
    transform: "translate(-140.047 -100.921)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17715",
    "data-name": "Path 17715",
    d: "M341.925,303.5a2.027,2.027,0,0,0-2.456-.909,1.784,1.784,0,0,0-1.016.946c-.02.046-.031.095-.047.142s-.049.068-.068.105a2.025,2.025,0,0,0,3.159,2.42A2.181,2.181,0,0,0,341.925,303.5Zm-1.277.866C340.651,304.389,340.65,304.413,340.647,304.363Zm-.13-.3Zm-.572.23Zm.136.115C340.113,304.424,340.1,304.422,340.081,304.413Zm.061.029.013-.006-.01,0h.007c.005,0,.006,0,.006,0,.061-.028.02-.014-.016,0h0a.233.233,0,0,0-.07-.022l-.007,0c-.02-.014-.118-.091-.027-.01-.02-.018-.04-.035-.058-.054a.264.264,0,0,1-.03-.037l-.035-.062,0-.011c0-.009,0-.013,0-.019s0-.012,0-.018a.22.22,0,0,0,.013-.057l0,0c.015-.02.027-.044.041-.066-.074.112.029-.012.037-.028s0,0,0,0l.006,0c.023-.013.045-.029.068-.041s.137-.046.024-.014c.026-.007.05-.017.076-.023l.063-.01h.037l.025,0c-.019,0,.064.02.089.024l.01.008c.021.015.046.029.068.043-.1-.064,0,.005.02.024l.032.035a.28.28,0,0,1,.026.036c.016.03.033.06.05.089l0,.007v0a.807.807,0,0,0,.039.139.112.112,0,0,1,0,.012c0,.026,0,.052,0,.078v.005a.559.559,0,0,0-.51,0Z",
    transform: "translate(-268.028 -266.732)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17716",
    "data-name": "Path 17716",
    d: "M212.168,152.9h0Z",
    transform: "translate(-140.041 -100.923)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17717",
    "data-name": "Path 17717",
    d: "M344.113,350.255h0Z",
    transform: "translate(-271.983 -298.274)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17718",
    "data-name": "Path 17718",
    d: "M344.111,350.257h0Z",
    transform: "translate(-271.98 -298.275)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17719",
    "data-name": "Path 17719",
    d: "M344.114,350.255s0,0,0,0Z",
    transform: "translate(-271.983 -298.274)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17720",
    "data-name": "Path 17720",
    d: "M404.925,380.5a2.027,2.027,0,0,0-2.456-.909,1.784,1.784,0,0,0-1.016.946c-.02.046-.031.095-.047.142s-.049.068-.068.105a2.025,2.025,0,0,0,3.159,2.42A2.181,2.181,0,0,0,404.925,380.5Zm-1.277.866C403.651,381.389,403.65,381.413,403.647,381.363Zm-.13-.3Zm-.572.23Zm.136.115C403.113,381.424,403.1,381.422,403.081,381.413Zm.061.029.013-.006-.01,0h.007c.005,0,.006,0,.006,0,.061-.028.02-.014-.016,0h0a.231.231,0,0,0-.07-.022l-.007,0c-.02-.014-.118-.091-.027-.01-.02-.018-.04-.035-.058-.054a.271.271,0,0,1-.03-.037l-.035-.062,0-.011c0-.009,0-.013,0-.019s0-.012,0-.018a.22.22,0,0,0,.013-.057l0,0c.015-.02.027-.044.041-.065-.074.112.029-.012.037-.028s0,0,0,0l.006,0c.023-.013.045-.029.068-.041s.137-.046.024-.014c.026-.007.05-.017.076-.023l.063-.01h.037l.025,0c-.019,0,.064.021.089.024l.01.008c.021.015.046.029.068.043-.1-.064,0,.005.02.024s.022.023.032.035a.273.273,0,0,1,.026.036c.016.03.033.06.05.089l0,.007a.024.024,0,0,0,0,0,.8.8,0,0,0,.039.139.112.112,0,0,1,0,.012c0,.026,0,.052,0,.078v.005a.558.558,0,0,0-.509,0Z",
    transform: "translate(-309.611 -317.555)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17721",
    "data-name": "Path 17721",
    d: "M275.168,121.9h0Z",
    transform: "translate(-181.623 -80.462)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17722",
    "data-name": "Path 17722",
    d: "M407.113,319.255h0Z",
    transform: "translate(-313.565 -277.813)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17723",
    "data-name": "Path 17723",
    d: "M407.111,319.257h0Z",
    transform: "translate(-313.563 -277.814)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17724",
    "data-name": "Path 17724",
    d: "M407.114,319.255s0,0,0,0Z",
    transform: "translate(-313.566 -277.813)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17725",
    "data-name": "Path 17725",
    d: "M275.177,121.9Z",
    transform: "translate(-181.63 -80.46)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17726",
    "data-name": "Path 17726",
    d: "M466.113,339.255h0Z",
    transform: "translate(-352.508 -291.014)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17727",
    "data-name": "Path 17727",
    d: "M463.925,334.5a2.027,2.027,0,0,0-2.456-.909,1.784,1.784,0,0,0-1.016.946c-.02.046-.031.095-.047.142s-.049.068-.068.105a2.025,2.025,0,0,0,3.159,2.42A2.181,2.181,0,0,0,463.925,334.5Zm-1.277.866C462.651,335.389,462.65,335.413,462.647,335.363Zm-.13-.3Zm-.572.23Zm.136.115C462.113,335.424,462.1,335.422,462.081,335.413Zm.061.029.013-.006-.01,0h.007c.005,0,.006,0,.006,0,.061-.028.02-.014-.016,0h0a.233.233,0,0,0-.07-.022l-.007,0c-.02-.014-.118-.091-.027-.01-.02-.018-.04-.035-.058-.054a.266.266,0,0,1-.03-.037l-.035-.062,0-.011c0-.009,0-.013,0-.019s0-.012,0-.018a.219.219,0,0,0,.013-.057l0,0c.015-.02.027-.044.041-.066-.074.112.029-.012.037-.028s0,0,0,0l.006,0c.023-.014.045-.029.068-.041s.137-.046.024-.014c.026-.007.05-.017.076-.023l.063-.01h.037l.025,0c-.019,0,.064.02.089.024l.01.008c.021.015.046.029.068.043-.1-.064,0,.005.02.024s.022.023.032.035a.277.277,0,0,1,.026.036c.016.03.033.06.05.089l0,.008a.022.022,0,0,0,0,0,.806.806,0,0,0,.039.139s0,.008,0,.012c0,.026,0,.052,0,.078v.005a.558.558,0,0,0-.51,0Z",
    transform: "translate(-348.553 -287.193)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17728",
    "data-name": "Path 17728",
    d: "M334.168,141.9h0Z",
    transform: "translate(-220.566 -93.663)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17729",
    "data-name": "Path 17729",
    d: "M334.177,141.9Z",
    transform: "translate(-220.572 -93.661)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17730",
    "data-name": "Path 17730",
    d: "M466.114,339.255s0,0,0,0Z",
    transform: "translate(-352.508 -291.014)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17731",
    "data-name": "Path 17731",
    d: "M466.111,339.257h0Z",
    transform: "translate(-352.505 -291.015)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17732",
    "data-name": "Path 17732",
    d: "M418.534,380.343l-15.807.879a.349.349,0,0,1-.075-.692l16.156-2.629Z",
    transform: "translate(-310.427 -316.521)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17733",
    "data-name": "Path 17733",
    d: "M505,469.144l5.957-10.021,4.4,2.079s-7.586,9.475-7.828,9.748A2.331,2.331,0,1,1,505,469.144Z",
    transform: "translate(-376.806 -370.131)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17734",
    "data-name": "Path 17734",
    d: "M514.2,420.126l9.651,5.035a5.343,5.343,0,0,1,.9,7.846l-6.653,7.632-2.9-3.927,2.234-4.671-4.326-1.141Z",
    transform: "translate(-383.532 -344.392)",
    fill: "#8297ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17735",
    "data-name": "Path 17735",
    d: "M423.856,377.19,422.769,388.8l-4.869.008s2.794-11.812,2.9-12.162a2.331,2.331,0,1,1,3.061.547Z",
    transform: "translate(-320.685 -313.205)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17736",
    "data-name": "Path 17736",
    d: "M430.523,419.465l-11.207-2.055c-4.719-.568-6.656-3.673-5.8-6.7l2.74-9.747,4.3,2.306-.017,5.178,6.022-.823Z",
    transform: "translate(-317.66 -331.743)",
    fill: "#8297ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17737",
    "data-name": "Path 17737",
    d: "M309.672,470.916h-3.081l-1.466-11.886h4.548Z",
    transform: "translate(-201.397 -302.978)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17738",
    "data-name": "Path 17738",
    d: "M432.357,690.856h-9.476v-.12a3.688,3.688,0,0,1,3.688-3.688h0l1.731-1.313,3.229,1.313h.827Z",
    transform: "translate(-323.973 -519.705)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17739",
    "data-name": "Path 17739",
    d: "M382.635,470.916h3.081l1.466-11.886h-4.548Z",
    transform: "translate(-252.556 -302.978)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17740",
    "data-name": "Path 17740",
    d: "M514.251,690.856h9.476v-.12a3.688,3.688,0,0,0-3.688-3.688h0l-1.731-1.313-3.229,1.313h-.827Z",
    transform: "translate(-384.28 -519.705)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17741",
    "data-name": "Path 17741",
    d: "M436.649,554.951c.046-.678.407-4.429.407-4.429l.867-7.954,1.528-21.085,1.362-5.542,6.74,2.626,5.469-2.622,6.5,2.078,5.062,1.9s.009.813.048,1.794a13.432,13.432,0,0,0,.36,3.27c.362.724.271,4.609.271,4.609s.36,7.9.813,8.771a6.02,6.02,0,0,1,.407,3.033c-.136.362.453,9.854.453,9.854s1.513,16.8.564,19.331-4.535.874-4.535.874.173-.676-.867-.995-4.208-24.138-4.208-24.138a46.279,46.279,0,0,0-1.131-6.284,35.818,35.818,0,0,1-1.04-5.332s-3.345-6.509-3.389-7.956c0,0-.438-1.354-.852.136s-1.634,5.062-1.634,5.062l-1.19,4.386-1.4,6.552-.906,5.517s-1.356,7.321-1.573,7.638,0,7.005,0,7.005-1.049,5.7-2.531,6.691-5.409.016-5.409.016S436.6,555.629,436.649,554.951Z",
    transform: "translate(-333.056 -407.633)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17742",
    "data-name": "Path 17742",
    d: "M443.14,427.785l-.861,11.157-1.294,1.339a1.248,1.248,0,0,0,.065,1.8h0l-.713,1.222-.252,3.852a2.094,2.094,0,0,0,1.937,2.58l22.312,1.048a2.094,2.094,0,0,0,2.174-2.367l-1.9-14.283v-1.068L463.761,431l.437-6.909,1.015-10.967-5.9-1.525-3.2-2.2-5.56.089-3.374,2.771-4.5.7-3.4.676-.433.942.867-.188,3.141,12.253Z",
    transform: "translate(-334.509 -337.311)",
    fill: "#8297ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1024",
    "data-name": "Ellipse 1024",
    cx: 6.55,
    cy: 6.55,
    r: 6.55,
    transform: "translate(112.148 57.493)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17743",
    "data-name": "Path 17743",
    d: "M461.935,376.415l4.732-.241a1.952,1.952,0,0,0,2.246-1.393c.437-1.016.875-2.032,1.3-3.053a9.354,9.354,0,0,0,1.018-4.426,2.817,2.817,0,0,0-.819-1.846,1.564,1.564,0,0,0-1.9-.193,3.213,3.213,0,0,0-1.6-2.316,4.925,4.925,0,0,0-2.809-.6,6.779,6.779,0,0,0-3.861,1.522,8.379,8.379,0,0,1-.985.78,1.546,1.546,0,0,1-1.2.222.87.87,0,0,1-.639-.948,1.674,1.674,0,0,0-.428,2.21,1.545,1.545,0,0,1-1.509-.179,1.845,1.845,0,1,0,1.935,3.124,2.168,2.168,0,0,1,.143,1.442c-.037.493.095,1.105.57,1.242.642.184,1.163-.681,1.831-.672a1,1,0,0,1,.8.513,2.965,2.965,0,0,1,.319.931l.855,3.85",
    transform: "translate(-344.816 -306.246)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17744",
    "data-name": "Path 17744",
    d: "M790.859,562.782c0-1.014-.341-1.837-.759-1.839h-114c-.42,0-.759.825-.761,1.839v41.75a.379.379,0,0,1-.342.377q-.459.044-.918.082l-.023,0c-.167.015-.333.026-.5.04h0q-.129-.238-.254-.479a.38.38,0,0,1-.043-.176V560.4c0-.28.011-.562.03-.84a10.767,10.767,0,0,1,.142-1.139c.32-1.758,1.043-2.948,1.864-2.952H790.9a.887.887,0,0,1,.348.074,1.358,1.358,0,0,1,.43.3,2.662,2.662,0,0,1,.422.577,7.6,7.6,0,0,1,.8,3.014c0,.011,0,.023,0,.034.026.307.04.619.038.931l.026,4.055.017,2.418.051,7.588.019,2.695.083,27.664h0a.378.378,0,0,1-.378.378h-1.521a.378.378,0,0,1-.378-.378Z",
    transform: "translate(-489.23 -433.721)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17745",
    "data-name": "Path 17745",
    d: "M902.948,499.652H890.663a.655.655,0,0,0-.654.656v19.405H903.6V500.308a.656.656,0,0,0-.656-.656Zm-6.1,11.026a1.457,1.457,0,0,1-1.451-1.451v-2.238a1.451,1.451,0,1,1,2.9,0v2.238A1.457,1.457,0,0,1,896.847,510.678Z",
    transform: "translate(-632.296 -396.882)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17746",
    "data-name": "Path 17746",
    d: "M889.884,556.837v1.872a.367.367,0,0,0,.366.366H903.2a.368.368,0,0,0,.366-.366v-1.872Z",
    transform: "translate(-632.214 -434.627)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17747",
    "data-name": "Path 17747",
    d: "M882.648,410.571h-52.51a1.7,1.7,0,0,0-1.7,1.7v35.434a1.7,1.7,0,0,0,1.7,1.7h52.51a1.7,1.7,0,0,0,1.7-1.7V412.273A1.7,1.7,0,0,0,882.648,410.571Z",
    transform: "translate(-591.656 -338.085)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17748",
    "data-name": "Path 17748",
    d: "M884.6,414.186H832.967a.912.912,0,0,0-.91.912v34.556a.912.912,0,0,0,.91.91H884.6a.912.912,0,0,0,.91-.91V415.1a.912.912,0,0,0-.91-.912Z",
    transform: "translate(-594.045 -340.471)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17749",
    "data-name": "Path 17749",
    d: "M896.291,558.747H865.573a.565.565,0,0,1-.553-.681l.477-2.264a.567.567,0,0,1,.553-.449h29.765a.567.567,0,0,1,.553.449l.477,2.264a.565.565,0,0,1-.553.682Z",
    transform: "translate(-615.794 -433.648)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3894",
    "data-name": "Rectangle 3894",
    width: 0.946,
    height: 0.568,
    rx: 0.284,
    transform: "translate(250.473 122.114)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3895",
    "data-name": "Rectangle 3895",
    width: 0.946,
    height: 0.568,
    rx: 0.284,
    transform: "translate(252.365 122.114)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3896",
    "data-name": "Rectangle 3896",
    width: 0.946,
    height: 0.568,
    rx: 0.284,
    transform: "translate(254.257 122.114)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3897",
    "data-name": "Rectangle 3897",
    width: 0.946,
    height: 0.568,
    rx: 0.284,
    transform: "translate(256.15 122.114)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3898",
    "data-name": "Rectangle 3898",
    width: 0.946,
    height: 0.568,
    rx: 0.284,
    transform: "translate(258.042 122.114)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3899",
    "data-name": "Rectangle 3899",
    width: 0.946,
    height: 0.568,
    rx: 0.284,
    transform: "translate(259.934 122.114)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3900",
    "data-name": "Rectangle 3900",
    width: 0.946,
    height: 0.568,
    rx: 0.284,
    transform: "translate(261.826 122.114)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3901",
    "data-name": "Rectangle 3901",
    width: 0.946,
    height: 0.568,
    rx: 0.284,
    transform: "translate(263.719 122.114)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3902",
    "data-name": "Rectangle 3902",
    width: 0.946,
    height: 0.568,
    rx: 0.284,
    transform: "translate(265.611 122.114)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3903",
    "data-name": "Rectangle 3903",
    width: 0.946,
    height: 0.568,
    rx: 0.284,
    transform: "translate(267.503 122.114)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3904",
    "data-name": "Rectangle 3904",
    width: 0.946,
    height: 0.568,
    rx: 0.284,
    transform: "translate(269.395 122.114)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3905",
    "data-name": "Rectangle 3905",
    width: 0.946,
    height: 0.568,
    rx: 0.284,
    transform: "translate(271.287 122.114)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3906",
    "data-name": "Rectangle 3906",
    width: 0.946,
    height: 0.568,
    rx: 0.284,
    transform: "translate(273.18 122.114)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3907",
    "data-name": "Rectangle 3907",
    width: 0.946,
    height: 0.568,
    rx: 0.284,
    transform: "translate(275.072 122.114)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3908",
    "data-name": "Rectangle 3908",
    width: 0.946,
    height: 0.568,
    rx: 0.284,
    transform: "translate(276.964 122.114)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3909",
    "data-name": "Rectangle 3909",
    width: 0.946,
    height: 0.568,
    rx: 0.284,
    transform: "translate(278.856 122.114)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3910",
    "data-name": "Rectangle 3910",
    width: 0.946,
    height: 0.568,
    rx: 0.284,
    transform: "translate(250.451 123.06)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3911",
    "data-name": "Rectangle 3911",
    width: 0.946,
    height: 0.568,
    rx: 0.284,
    transform: "translate(252.343 123.06)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3912",
    "data-name": "Rectangle 3912",
    width: 0.946,
    height: 0.568,
    rx: 0.284,
    transform: "translate(254.235 123.06)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3913",
    "data-name": "Rectangle 3913",
    width: 0.946,
    height: 0.568,
    rx: 0.284,
    transform: "translate(256.127 123.06)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3914",
    "data-name": "Rectangle 3914",
    width: 0.946,
    height: 0.568,
    rx: 0.284,
    transform: "translate(258.019 123.06)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3915",
    "data-name": "Rectangle 3915",
    width: 0.946,
    height: 0.568,
    rx: 0.284,
    transform: "translate(259.912 123.06)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3916",
    "data-name": "Rectangle 3916",
    width: 0.946,
    height: 0.568,
    rx: 0.284,
    transform: "translate(261.804 123.06)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3917",
    "data-name": "Rectangle 3917",
    width: 0.946,
    height: 0.568,
    rx: 0.284,
    transform: "translate(263.696 123.06)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3918",
    "data-name": "Rectangle 3918",
    width: 0.946,
    height: 0.568,
    rx: 0.284,
    transform: "translate(265.588 123.06)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3919",
    "data-name": "Rectangle 3919",
    width: 0.946,
    height: 0.568,
    rx: 0.284,
    transform: "translate(267.48 123.06)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3920",
    "data-name": "Rectangle 3920",
    width: 0.946,
    height: 0.568,
    rx: 0.284,
    transform: "translate(269.373 123.06)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3921",
    "data-name": "Rectangle 3921",
    width: 0.946,
    height: 0.568,
    rx: 0.284,
    transform: "translate(271.265 123.06)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3922",
    "data-name": "Rectangle 3922",
    width: 0.946,
    height: 0.568,
    rx: 0.284,
    transform: "translate(273.157 123.06)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3923",
    "data-name": "Rectangle 3923",
    width: 0.946,
    height: 0.568,
    rx: 0.284,
    transform: "translate(275.049 123.06)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3924",
    "data-name": "Rectangle 3924",
    width: 0.946,
    height: 0.568,
    rx: 0.284,
    transform: "translate(276.942 123.06)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3925",
    "data-name": "Rectangle 3925",
    width: 0.946,
    height: 0.568,
    rx: 0.284,
    transform: "translate(278.834 123.06)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3926",
    "data-name": "Rectangle 3926",
    width: 7.569,
    height: 0.568,
    rx: 0.284,
    transform: "translate(259.533 124.195)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17750",
    "data-name": "Path 17750",
    d: "M884.805,427.445H836.493a.192.192,0,0,1,0-.384h48.312a.192.192,0,0,1,0,.384Z",
    transform: "translate(-596.847 -348.969)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1025",
    "data-name": "Ellipse 1025",
    cx: 1.126,
    cy: 1.151,
    rx: 1.126,
    ry: 1.151,
    transform: "translate(241.809 74.809)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1026",
    "data-name": "Ellipse 1026",
    cx: 1.126,
    cy: 1.151,
    rx: 1.126,
    ry: 1.151,
    transform: "translate(245.699 74.809)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1027",
    "data-name": "Ellipse 1027",
    cx: 1.126,
    cy: 1.151,
    rx: 1.126,
    ry: 1.151,
    transform: "translate(249.588 74.809)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17751",
    "data-name": "Path 17751",
    d: "M966.319,418.243h-2.763a.209.209,0,1,0,0,.418h2.763a.209.209,0,1,0,0-.418Z",
    transform: "translate(-680.702 -343.149)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17752",
    "data-name": "Path 17752",
    d: "M966.319,420.553h-2.763a.209.209,0,0,0,0,.418h2.763a.209.209,0,1,0,0-.418Z",
    transform: "translate(-680.702 -344.674)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17753",
    "data-name": "Path 17753",
    d: "M966.319,422.86h-2.763a.209.209,0,1,0,0,.418h2.763a.209.209,0,1,0,0-.418Z",
    transform: "translate(-680.702 -346.196)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3927",
    "data-name": "Rectangle 3927",
    width: 7.679,
    height: 1.642,
    rx: 0.821,
    transform: "translate(260.845 88.943)",
    fill: "#ca373c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3928",
    "data-name": "Rectangle 3928",
    width: 15.479,
    height: 1.642,
    rx: 0.821,
    transform: "translate(256.945 92.227)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3929",
    "data-name": "Rectangle 3929",
    width: 15.479,
    height: 1.642,
    rx: 0.821,
    transform: "translate(256.945 95.511)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17754",
    "data-name": "Path 17754",
    d: "M519.323,406.278l-2.783-1.331,3.823-11.632,4.107,1.964Z",
    transform: "translate(-340.939 -259.603)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17755",
    "data-name": "Path 17755",
    d: "M697.708,601.965c-.2.127-.4.251-.609.376-.407.249-.818.495-1.229.736-.206.121-.415.241-.621.36v.006l-.012,0,0,0-.315.078-.452-1.194-.208-.55-.294-.779-.54-1.425-2.841-7.5,4.418-1.09.166.677h0l.082.335,1.543,6.259.315,1.28.01.039.19.765.164.662.182.74Z",
    transform: "translate(-500.666 -457.166)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17756",
    "data-name": "Path 17756",
    d: "M717.678,519.732c-.28.45-.566.9-.854,1.341q-.8,1.239-1.65,2.441s0,0,0,0a5.773,5.773,0,0,1-1.083.791c-.016.012-.035.02-.051.031a3.994,3.994,0,0,1-.912.366l-.346.086c-.413.1-.822.182-1.229.255-.724.129-1.439.221-2.15.278-.057.006-.115.01-.172.014a33.258,33.258,0,0,1-8.745-.7c-1.468-.278-2.966-.611-4.518-.957-.507-.115-1.016-.227-1.531-.339l-.121-.027c-.736-.161-1.484-.321-2.251-.478-.965-.2-1.96-.39-2.995-.572l.074,1.458a10.968,10.968,0,0,0,.691,3.277,5.656,5.656,0,0,1,.053,4.442l-.356,1.03a3.519,3.519,0,0,1-.362,3.113l-.071.108,2.966,7.5.192.487h-1.519l-1.868,0H685.7l-4.569-9.166-.219-.437v-.022l.472-17.615c.006-.155.018-.313.039-.468a5.355,5.355,0,0,1,2.038-3.606,5.157,5.157,0,0,1,3.841-1.051l1.564.2,3.2.413,2.251.292.045.006L701,513.1l.476-1.942.088-.033,2.794-1.024,9.665-3.543.025-.008.636-.233.076.123c.022.037.045.074.065.11a18.941,18.941,0,0,1,1.527,3.545,55.634,55.634,0,0,1,1.6,6.126q.028.135.049.245l.006.022c.006.035.01.057.012.063A5.717,5.717,0,0,1,717.678,519.732Z",
    transform: "translate(-494.285 -401.28)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17757",
    "data-name": "Path 17757",
    d: "M701.018,507.885c-.031-.131-.07-.264-.11-.392a27.966,27.966,0,0,0-1.132-2.866c-.482-1.063-1.061-2.2-1.75-3.434q-.5-.9-1.075-1.862-.288-.484-.6-.987a.511.511,0,0,0-.027-.045l-.059-.1-9.563,1.28-3.561.476-.213,1.774-.051.439s0,0,0,0l-.143,1.2v0l-.19,1.582-.016,0-5.284-.685-5.446-.705-2.925-.378a5.154,5.154,0,0,0-3.841,1.051,5.358,5.358,0,0,0-2.038,3.606c-.018.143-.031.29-.037.435l-2.76,6.539a42.19,42.19,0,0,0-3.119,12.273l-2.024,6.47.288.027,4.289.4,1.133.106,2.494-3.641c.284-.415.554-.842.805-1.28a19.451,19.451,0,0,0,1.1-2.216l5.395-12.838q.626.107,1.239.2,2.836.46,5.446.75a64.175,64.175,0,0,0,14.915.145q1.837-.224,3.551-.589.629-.132,1.241-.284c.1-.022.19-.045.284-.069a5.217,5.217,0,0,0,3.649-3.41A5.323,5.323,0,0,0,701.018,507.885Z",
    transform: "translate(-477.217 -395.923)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17758",
    "data-name": "Path 17758",
    d: "M638.918,619.968l-3.011-1.443-.472-.227-.754,1.852-5.266,1.159a1.249,1.249,0,0,0-.2,2.377l5.145,2.1,1.633-1.47-.4,1.973,1.938.791,2.124-6.76Z",
    transform: "translate(-459.645 -475.194)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17759",
    "data-name": "Path 17759",
    d: "M581.774,417.469l.192.486h-.192Z",
    transform: "translate(-383.996 -275.546)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17760",
    "data-name": "Path 17760",
    d: "M698.955,616.043l-3.155,1.093-.5.171.767,1.847-2.926,4.529a1.249,1.249,0,0,0,1.527,1.833l5.133-2.129.126-2.194,1.1,1.684,1.934-.8-3.247-6.3Z",
    transform: "translate(-502.226 -473.53)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17761",
    "data-name": "Path 17761",
    d: "M653.8,411.2a2.241,2.241,0,0,0,3.351.76l6.635,4.4.013-4.138-6.3-3.548a2.253,2.253,0,0,0-3.7,2.522Z",
    transform: "translate(-476.219 -336.328)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17762",
    "data-name": "Path 17762",
    d: "M668.874,416.39l3.1-3.522,12.6,7.482,16.708-1.53a5.65,5.65,0,0,1,6.141,6.147h0a5.656,5.656,0,0,1-6.146,5.1l-18.817-1.742Z",
    transform: "translate(-486.338 -339.601)",
    fill: "#ff8084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17763",
    "data-name": "Path 17763",
    d: "M752.055,423.2l-.029-.036h0a12.207,12.207,0,0,0-11.814,6.121l-1.418,2.5c-4.586,5.607-1.254,9.474-1.054,10.049l-1.592,7.34.357,2.457.178.73,18.172,9.5c1.035-4.971.034-9.207-3.735-12.443l3.647-11.347A15.985,15.985,0,0,0,752.055,423.2Z",
    transform: "translate(-530.742 -346.358)",
    fill: "#ff8084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17764",
    "data-name": "Path 17764",
    d: "M726.039,564.405H720.21a1.332,1.332,0,0,1-1.317-1.145,29.638,29.638,0,0,1,0-7.982,1.332,1.332,0,0,1,1.3-1.144,7.293,7.293,0,0,1,5.871,0,1.316,1.316,0,0,1,1,.483,1.347,1.347,0,0,1,.278,1.122,17.918,17.918,0,0,0,0,7.06,1.347,1.347,0,0,1-.278,1.122A1.316,1.316,0,0,1,726.039,564.405Z",
    transform: "translate(-519.174 -432.436)",
    fill: "#17256b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17765",
    "data-name": "Path 17765",
    d: "M728.521,563.091h-4.906a.307.307,0,0,1,0-.613h4.906a.307.307,0,0,1,0,.613Z",
    transform: "translate(-522.267 -438.35)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17766",
    "data-name": "Path 17766",
    d: "M728.521,570.307h-4.906a.307.307,0,1,1,0-.613h4.906a.307.307,0,0,1,0,.613Z",
    transform: "translate(-522.267 -443.113)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17767",
    "data-name": "Path 17767",
    d: "M728.521,577.523h-4.906a.307.307,0,0,1,0-.613h4.906a.307.307,0,0,1,0,.613Z",
    transform: "translate(-522.267 -447.876)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17768",
    "data-name": "Path 17768",
    d: "M643.039,402.405H637.21a1.332,1.332,0,0,1-1.317-1.145,29.638,29.638,0,0,1,0-7.982,1.332,1.332,0,0,1,1.3-1.144,7.293,7.293,0,0,1,5.871,0,1.316,1.316,0,0,1,1,.483,1.347,1.347,0,0,1,.278,1.122,17.918,17.918,0,0,0,0,7.06,1.346,1.346,0,0,1-.278,1.122A1.316,1.316,0,0,1,643.039,402.405Z",
    transform: "translate(-464.391 -325.509)",
    fill: "#17256b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17769",
    "data-name": "Path 17769",
    d: "M645.521,401.091h-4.906a.307.307,0,0,1,0-.613h4.906a.307.307,0,0,1,0,.613Z",
    transform: "translate(-467.484 -331.423)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17770",
    "data-name": "Path 17770",
    d: "M645.521,408.307h-4.906a.307.307,0,1,1,0-.613h4.906a.307.307,0,0,1,0,.613Z",
    transform: "translate(-467.484 -336.186)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17771",
    "data-name": "Path 17771",
    d: "M645.521,415.523h-4.906a.307.307,0,1,1,0-.613h4.906a.307.307,0,1,1,0,.613Z",
    transform: "translate(-467.484 -340.949)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17772",
    "data-name": "Path 17772",
    d: "M342.039,446.405H336.21a1.331,1.331,0,0,1-1.317-1.145,29.638,29.638,0,0,1,0-7.982,1.332,1.332,0,0,1,1.3-1.144,7.292,7.292,0,0,1,5.871,0,1.316,1.316,0,0,1,1,.483,1.347,1.347,0,0,1,.278,1.122,17.918,17.918,0,0,0,0,7.06,1.347,1.347,0,0,1-.278,1.122A1.316,1.316,0,0,1,342.039,446.405Z",
    transform: "translate(-265.719 -354.551)",
    fill: "#17256b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17773",
    "data-name": "Path 17773",
    d: "M344.521,445.091h-4.906a.307.307,0,0,1,0-.613h4.906a.307.307,0,1,1,0,.613Z",
    transform: "translate(-268.812 -360.465)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17774",
    "data-name": "Path 17774",
    d: "M344.521,452.307h-4.906a.307.307,0,1,1,0-.613h4.906a.307.307,0,1,1,0,.613Z",
    transform: "translate(-268.812 -365.228)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17775",
    "data-name": "Path 17775",
    d: "M344.521,459.523h-4.906a.307.307,0,0,1,0-.613h4.906a.307.307,0,1,1,0,.613Z",
    transform: "translate(-268.812 -369.991)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17776",
    "data-name": "Path 17776",
    d: "M738.839,543.678a2.241,2.241,0,0,0,.559-3.39l4-6.884-4.132.233-3.168,6.5a2.253,2.253,0,0,0,2.737,3.54Z",
    transform: "translate(-530.266 -419.16)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17777",
    "data-name": "Path 17777",
    d: "M743.031,473.035l-3.7-2.881,6.721-13.025-2.519-16.587a5.65,5.65,0,0,1,5.772-6.495h0a5.656,5.656,0,0,1,5.46,5.833l-.622,18.887Z",
    transform: "translate(-532.844 -353.578)",
    fill: "#ff8084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17778",
    "data-name": "Path 17778",
    d: "M216.762,496.879a2.259,2.259,0,0,0-.314-3.45l3.6-17.868-3.973,1.276-2.88,17.283a2.272,2.272,0,0,0,3.569,2.76Z",
    transform: "translate(-185.357 -380.981)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17779",
    "data-name": "Path 17779",
    d: "M220.584,423.452l-2.465-1.861s-2.174-.154-2.56,3.767-1.176,11.563-1.176,11.563l-3.772,17.469,5.221,1.146,4.04-18.852,2.423-5.6Z",
    transform: "translate(-183.867 -345.358)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17780",
    "data-name": "Path 17780",
    d: "M96.057,294.746l13.89-.231,1.158-9.491H96.057Z",
    transform: "translate(-63.403 -188.127)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17781",
    "data-name": "Path 17781",
    d: "M132.827,461.414h3.206l1.525-12.368h-4.733Z",
    transform: "translate(-87.672 -296.389)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17782",
    "data-name": "Path 17782",
    d: "M73.738,462.224l3.206-.023,1.439-12.378-4.17.957Z",
    transform: "translate(-48.672 -296.901)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17783",
    "data-name": "Path 17783",
    d: "M101.827,258.158l-.726,1.889.145,1.889,14.219,4.925-.705-8.267-1.6-1.889Z",
    transform: "translate(-66.732 -169.436)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1028",
    "data-name": "Ellipse 1028",
    cx: 5.079,
    cy: 5.079,
    r: 5.079,
    transform: "translate(36.117 61.566)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17784",
    "data-name": "Path 17784",
    d: "M261.182,677.539l5.069-.3v2.172l4.819,3.328a1.357,1.357,0,0,1-.771,2.473h-6.035l-1.04-2.148-.406,2.148h-2.275Z",
    transform: "translate(-216.823 -514.095)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17785",
    "data-name": "Path 17785",
    d: "M201.309,678.366l5.067-.338.015,2.172,4.842,3.294a1.357,1.357,0,0,1-.754,2.478l-6.034.042-1.055-2.141L203,686.024l-2.275.016Z",
    transform: "translate(-177.34 -514.617)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17786",
    "data-name": "Path 17786",
    d: "M201.319,551.207l2.335-18.663,2.778-19.677c-2.034-3.778,2.546-15.51,2.546-15.51l.647.031,14.635,2.761,0-.014c2.993,8.164,3.985,12.2,3.821,20.892l-.59,31.254h.185a1.158,1.158,0,0,1,0,2.315h-5.787a1.158,1.158,0,1,1,0-2.315h.149l-5.312-37.214-4.5,15.626-5.093,20.372c1.852-.463,1.564.61,1.564,1.217a1.158,1.158,0,0,1-1.157,1.158h-5.787a1.156,1.156,0,0,1-.427-2.231Z",
    transform: "translate(-177.25 -395.367)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17787",
    "data-name": "Path 17787",
    d: "M221.908,444.123l.463-4.63a.923.923,0,0,1,.835-.693c.193-2.206,1-11.72,1.053-12.135l0-.018.369-7.884a1.166,1.166,0,0,1,1.089-1.109l1.949-.127a.1.1,0,0,0,.1-.1,1.639,1.639,0,0,1,1.639-1.639h5.771a1.535,1.535,0,0,1,1.522,1.344.1.1,0,0,0,.1.092h0a2.742,2.742,0,0,1,2.758,2.274c.789,4.591,2.37,15.01,1.588,20.8-.272,2.016.315.419.417,2.107a1.242,1.242,0,0,1-.309.9.9.9,0,0,1,.539,1.138l.1-.025a.926.926,0,0,1-1.124.672l-15.1,2.046C225.181,447.009,221.784,444.619,221.908,444.123Z",
    transform: "translate(-191.32 -341.526)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17788",
    "data-name": "Path 17788",
    d: "M321.584,438.07a2.259,2.259,0,0,1-3.182,1.37l-5.837,5.327-.775-4.1,5.666-4.417a2.272,2.272,0,0,1,4.129,1.819Z",
    transform: "translate(-250.647 -354.297)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17789",
    "data-name": "Path 17789",
    d: "M268.813,424.4s-2.035-4.6-4.606-3.686-1.243,5.377-1.243,5.377l9.659,14.554s13.931-8.937,12.237-9-2.2-3.144-2.2-3.144l-7.363,3.679-.249-1.31-.4.4-1.03-.811Z",
    transform: "translate(-218.195 -344.704)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1029",
    "data-name": "Ellipse 1029",
    cx: 7.09,
    cy: 7.09,
    r: 7.09,
    transform: "translate(210.034 60.467)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17790",
    "data-name": "Path 17790",
    d: "M777.039,387.087a6.149,6.149,0,0,1-3.38,2.38,7.072,7.072,0,0,1-1.683.286,6.361,6.361,0,0,0-.5-1.869,5.251,5.251,0,0,1-.26,1.865,6.251,6.251,0,0,1-2.46-.659,5.421,5.421,0,0,1-2.9-3.89c-.3-1.939.579-3.844.9-5.78s-.28-4.389-2.176-4.9c-1.444-.388-1.282-.22-2.482.671,1.248,1.846-3.362,8.61-5.249,8.02-1.067-.333-1.75-1.312-1.97-1.312-1.483,2.555,1.309,6.859-1.5,7.753l.232-.232c1.7-2.09-1.852-6.512-.153-8.6a2.654,2.654,0,0,0,.838-2.017c-.133-.7-1.248-1.075-1.575-.5A2.655,2.655,0,0,0,751,374.817c-1.276-.308-1.253.071-2.533.236a6.353,6.353,0,0,0-.465-1.605,5.206,5.206,0,0,1-.191,1.636,2.054,2.054,0,0,1-1.242-.449c-1.044-.841-.833-2.609.1-3.573a6.412,6.412,0,0,1,3.642-1.535c.385-2.677,7.771-2.957,8.751-.281.417-2,2.918-3.034,4.862-2.415a6.861,6.861,0,0,1,4,4.348,43.934,43.934,0,0,1,1.346,5.961,9.858,9.858,0,0,0,2.7,5.378c1.522,1.356,4,1.805,5.607.545A4.49,4.49,0,0,1,777.039,387.087Z",
    transform: "translate(-537.158 -309.096)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17791",
    "data-name": "Path 17791",
    d: "M1007.274,469.637l-.993,4.98c-.075.381-.153.768-.238,1.152a4.857,4.857,0,0,0-2.5.139,23.294,23.294,0,0,1,1.713,2.866,10.547,10.547,0,0,1-3.08,5,7.724,7.724,0,0,1-7.462,1.312l.044-.2c-1.652-3.206-.755-7.248,1.3-10.209a19.853,19.853,0,0,1,3.689-3.9c1.387-1.156,2.886-2.193,4.372-3.216a2.036,2.036,0,0,1,3.151,2.074Z",
    transform: "translate(-700.872 -375.465)",
    fill: "#3a8365"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a4b268fa-75d0-4ac1-9d87-14bdca948464-2189-2",
    "data-name": "a4b268fa-75d0-4ac1-9d87-14bdca948464-2189",
    d: "M996.075,516.66a39.951,39.951,0,0,1-.554-9.2,14.473,14.473,0,0,1,2.791-7.588,12.624,12.624,0,0,1,3.239-2.935c.324-.2.622.309.3.512a12,12,0,0,0-4.747,5.727,19.213,19.213,0,0,0-1.02,8.286c.108,1.689.336,3.366.566,5.042a.306.306,0,0,1-.207.365.3.3,0,0,1-.365-.207Z",
    transform: "translate(-701.875 -395.058)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17792",
    "data-name": "Path 17792",
    d: "M449.781,700.769l-317.437.1a.4.4,0,0,1,0-.81l317.437-.1a.4.4,0,0,1,0,.81Z",
    transform: "translate(-131.939 -529.093)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17793",
    "data-name": "Path 17793",
    d: "M192.47,372c-.779.374-1.651-.189-2.323-.746l.241.208a7.91,7.91,0,0,0-2.016,4.458c-.272,1.636-.3,3.309-.644,4.933a6.992,6.992,0,0,1-2.38,4.247c-1.778,1.331-4.229,1.246-6.411.838l-.085-.016a13.318,13.318,0,0,0,.7-5.28,12.11,12.11,0,0,1-2.907,4.765,27.8,27.8,0,0,1-4.222-1.538,3.358,3.358,0,0,1-2.077-1.9,2.533,2.533,0,0,1,1.087-2.5A13.953,13.953,0,0,1,174,378.146a3.883,3.883,0,0,0,2.072-1.912c.8-2.068-1.48-4.442-.591-6.475A4.357,4.357,0,0,1,178,367.8a37,37,0,0,1,4.734-1.6,10.35,10.35,0,0,1,4.335-.419,4.306,4.306,0,0,1,3.373,2.491,4.669,4.669,0,0,1,2.341,1.351A1.617,1.617,0,0,1,192.47,372Z",
    transform: "translate(-157.252 -308.462)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17794",
    "data-name": "Path 17794",
    d: "M237.956,374.759c-2.228-1.759-4.03-1.459-5.42-.366-.234-.26-1.228.455-1.565.352l-1.218,2.286a5.077,5.077,0,0,0-.782,2.87c-1.153,3.232,1.581,5.415,4.813,6.567a6.168,6.168,0,0,0,4,.058l.04-.551.245.451s2.955,6.084,3.653,6.358c-.424-1.1-1.541-6.323-1.853-7.412a13.8,13.8,0,0,1,.116-5.278,8.179,8.179,0,0,0,.024-2.692l-.006-.039.691,1.4,1.551-.975C241.652,376.058,241.64,373.992,237.956,374.759Z",
    transform: "translate(-195.807 -313.621)",
    fill: "#2f2e41"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamdashboardimg);
export default __webpack_public_path__ + "static/media/teamdashboardimg.219957af581f1a6c1ab478e5fe3daa2a.svg";
export { ForwardRef as ReactComponent };